import CircularProgress from '@material-ui/core/CircularProgress';
import Button from './Button'

export default function ServerWaitButton ({ className, onClick, children, disabled = false, message = null, ...rest }) {
  const [saving, setSaving] = useState(false)
  const timeoutRef = useRef(null)
  const savingRef = useRef(saving)

  function doAction() {
    if (savingRef.current) {
      timeoutRef.current = setTimeout(doAction, 100)
    } else {
      setSaving(true)
      // the function onClick must return a promise.
      onClick().then(() => {
        setSaving(false)
      }).catch(() => {
        setSaving(false)
      })
    }
  }

  useEffect(() => {
    savingRef.current = saving
  }, [saving])

  // Ensure cleanup timeouts when we unmount
  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return <>
    <Button extraClass={className} onClick={doAction} type='button' disabled={disabled || saving} {...rest}>
      {children} { saving && <CircularProgress size={20} /> }
    </Button>
    { saving && message && <div><p className='no-margin-bottom error'>{message}</p></div> }
  </>
}